// src/containers/Maintenance.js
const Maintenance = () => {
    return (
      <div style={{ textAlign: 'center', paddingTop: '20vh' }}>
        <h1>🚧 Site en maintenance</h1>
        <p>Mon portfolio est actuellement en reconstruction.</p>
        <p>Revenez bientôt !</p>
      </div>
    );
  };
  
  export default Maintenance;